import { configureStore } from '@reduxjs/toolkit';
import { workspaceReducer } from '@/core/workspace';

// The shell store holds only shell-chrome state (the active workspace).
// Each remote app (e.g. Projects) owns its own Redux store and mounts its own
// <Provider> — no app slices are combined here, so remotes build independently.
export const store = configureStore({
  reducer: {
    workspace: workspaceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
